import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import RowButtons from './../../components/button/RowButtons';
import RowChangeButton from './../../components/button/RowChangeButton';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextAmount from 'components/text/TextAmount';
import TextDate from './../../components/text/TextDate';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const CollectionFeeList = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/collectionfee/summary/');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  const onDeleteClick = async (collectionFeeID) => {
    setIsPageLoading(true);
    const data = await apiPostCall(BASE_URL + '/admin/collectionfee/remove', {itemID : collectionFeeID});    
    if (isResultOk(data, setCheckErrorItems)){      
      await loadList();
    }
    setIsPageLoading(false);    
  }


  return (    
    <div>      
      <ListHeader title={t("Innheimtuþóknun")}/>          
      <div className="text-right"><Link to="/admin/collectionfees/edit?new=true" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna innheimtuþóknun")}</Link></div>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['120px','20%','','','','','','']}
          headers = {[
            t("Gildir frá"),
            t("Heiti innheimtulauna"),
            t("Grunngjald"),
            t("Beiðni og mót"),
            t("Vörslusvipting"),
            t("Afturköllun"),
            t("Frestun"),            
            ""
          ]}
          columns = {[
            (item) => <TextDate value={item.validFromDate}/>,
            (item) => <>
                        {item.name} <small>{(item.accessKey ? " ("+item.accessKey+")" : "")}</small><br/>
                        {item.linkedCollectionFeeID && <small className="text-nowrap ng-binding"> <i className="icon-link"></i> {item.linkedCollectionFeeName + (item.linkedCollectionFeeAccessKey ? " ("+item.linkedCollectionFeeAccessKey+")" : "")}</small>}
                    </>,        
            (item) => <div className="text-right"><TextAmount value={item.collectionBaseFee}/></div>,
            (item) => <div className="text-right"><TextAmount value={item.pleaOrMeetFee}/></div>,
            (item) => <div className="text-right"><TextAmount value={item.repossessPleaFee}/></div>,
            (item) => <div className="text-right"><TextAmount value={item.cancelFee}/></div>,
            (item) => <div className="text-right"><TextAmount value={item.delayFee}/></div>,            
            (item) => <RowButtons>
                        {item.isDeletable && <RowDeleteButton onClick={() => onDeleteClick(item.collectionFeeID)}/>}
                        <RowChangeButton link={"/admin/collectionfees/edit?collectionfeeid=" + item.collectionFeeID}/>                    
                      </RowButtons>,
          ]}

      />
  </div>
  );
};
